import { ReactNode } from 'react';
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import { useAccordionStyles } from './accordion.styles';

interface AccordionProps {
  children: ReactNode;
  title: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export const Accordion = (props: AccordionProps) => {
  // Component Styles
  const classes = useAccordionStyles();

  // Props
  const { children, title, buttonText, onButtonClick } = props;

  // JSX
  return (
    <MuiAccordion defaultExpanded className={classes.accordion}>
      <Box className={classes.accordionHeader}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="links-list-content"
          id="links-list-header"
          className={classes.accordionSummary}
        >
          <Typography>{title}</Typography>
        </AccordionSummary>
        {buttonText && onButtonClick && (
          <Button
            variant="outlined"
            className={classes.cardCtaButton}
            onClick={onButtonClick}
            data-testid="accordian-action-button"
          >
            {buttonText}
          </Button>
        )}
      </Box>
      <AccordionDetails className={classes.accordionDetails}>
        {children}
      </AccordionDetails>
    </MuiAccordion>
  );
};
